module.exports = __webpack_public_path__ + "static/media/sfondo_hb.3b0ce423.png";